export default "__VITE_ASSET__r8q_Wowd__"